import { Component } from '@angular/core';
import { soundpostControlAccountTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Control Account Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostcontrolaccounttype-form',
    templateUrl: './soundpostcontrolaccounttype.form.component.html'
})
export class soundpostControlAccountTypeFormComponent extends BaseFormComponent {
    public record!: soundpostControlAccountTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'gLAccounts', sectionName: 'GL Accounts', isExpanded: false },
            { sectionKey: 'reconBalanceSnapshots', sectionName: 'Recon Balance Snapshots', isExpanded: false }
        ]);
    }
}

